import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Modal from 'react-modal';

import s from './EditImageModal.module.scss';

Modal.setAppElement('#root');

export default class EditImageModal extends Component {
    static propTypes = {
        image: PropTypes.object,
        dateUploaded: PropTypes.object,
        editAltText: PropTypes.func,
        okLabel: PropTypes.string,
        cancelLabel: PropTypes.string,
        onClose: PropTypes.func,
        open: PropTypes.bool,
        accountId: PropTypes.string,
        openImageInNewTab: PropTypes.func,
    };

    static defaultProps = {
        image: {},
        dateUploaded: {},
        editAltText: () => {},
        okLabel: 'YES',
        cancelLabel: 'CANCEL',
        onClose: () => {},
        open: false,
        accountId: '',
        openImageInNewTab: () => {},
    };

    constructor(props) {
        super(props)
        this.state = {
            altText: props.image.alternativeText
        }
    }

    handleExit = () => {
        this.setState({ altText: this.props.image.alternativeText })
        this.props.onClose();
    };

    handleAltTextChange = event => {
        const newAltText = event.target.value;
        this.setState({ altText: newAltText });
    };

    handleSave = () => {
        this.props.editAltText(this.props.image, this.state.altText);
        this.handleExit()
    };

    renderInfo = (label, info) => (
        <div className={classNames(s.otherInfo, s.label)}>
            <div className={s.labelTab}>{`${label}:`}</div>
            <div className={s.info}>{info}</div>
        </div>
    );

    getImageType = img => img.contentType.split('/')[1].toUpperCase() || 'UNKNOWN';

    render() {
        const { image, open, accountId } = this.props;
        const dirty = this.state.altText !== image.alternativeText

        return (
            <Modal isOpen={open} className={s.modal} overlayClassName={s.overlay} onRequestClose={this.handleExit}>
                <button className={classNames(s.exitButton, 'icon-close')} type="button" onClick={this.handleExit} />
                <div className={s.modalContent}>
                    <div className={s.imageContainer}>
                        <img className={s.image} src={image.uri || `https://img.locuslabs.com/resize/${accountId}/1080x720cc/poi/${image.blobId}`} alt={image.caption} />
                    </div>

                    <div className={s.sidebarContainer}>
                        <div className={s.tmpImageName}>{image.caption || image.blobId}</div>
                        
                        <div className={s.inputGroup}>
                            <label htmlFor="alt-text-input" className={s.inputLabel}>Alternative Text:</label>
                            <input
                                id="alt-text-input"
                                type="text"
                                className={s.textInput}
                                value={this.state.altText}
                                onChange={this.handleAltTextChange}
                                placeholder="Enter alternative text for accessibility..."
                            />
                        </div>
                        <button 
                            className={s.saveButton} 
                            disabled={!dirty}
                            onClick={this.handleSave}
                        >
                            Save Changes
                        </button>
                        <a className={s.tmpViewBtn} target="_blank" rel="noopener noreferrer" href={image.uri || `http://img.locuslabs.com/poi/${image.blobId}`}>
                            <div>VIEW ORIGINAL IMAGE</div>
                        </a>
                    </div>
                </div>
            </Modal>
        );
    }
}
